<template>
  <div>
    <!-- 面包屑 -->
    <div class="position container yu_fc particles_box">
      <router-link to="/">首页</router-link><i></i>
      <template v-if="menu == 0">个人中心</template>
      <template v-if="menu == 1">地址管理</template>
      <template v-if="menu == 2">订单管理</template>
    </div>
    <!-- 面包屑 -->
    <!-- 个人中心 -->
    <div class="user container yu_fc particles_box">
      <div class="left">
        <h3>账号管理</h3>
        <ul>
          <li :class="menu == 0 ? 'active' : ''">
            <router-link :to="{ path: '/home', query: { key: 0 } }">个人中心</router-link>
          </li>
          <li :class="menu == 1 ? 'active' : ''">
            <router-link :to="{ path: '/addrList', query: { key: 1 } }">地址管理</router-link>
          </li>
          <li :class="menu == 2 ? 'active' : ''">
            <router-link :to="{ path: '/orderList', query: { key: 2 } }">订单管理</router-link>
          </li>
        </ul>
      </div>
      <div class="right">
        <router-view @getUser="showMsg"></router-view>
      </div>
    </div>
    <!-- 个人中心 -->
  </div>
</template>

<script>
export default {
  name: "user",
  data() {
    return {
      menu: 0 // 导航
    };
  },
  created() {
    console.log(this.$route.query.key)
    this.menu = this.$route.query.key
  },
  methods: {
    // val即为子组件传过来的值
    showMsg(val) {
      console.log(val)
      this.menu = val
    }
  }
};
</script>

<style scoped>
.user {
  background: #fff;
}
.user .left {
  float: left;
  width: 200px;
  height: 640px;
  border: 1px solid rgba(218, 218, 218, 1);
}
.user .left h3 {
  display: block;
  width: 100%;
  color: #333;
  font-size: 18px;
  font-weight: bold;
  padding: 46px 0 12px 46px;
}
.user .left ul {
  float: left;
  width: 100%;
}
.user .left ul li {
  float: left;
  padding: 8px 0 8px 46px;
  margin-bottom: 8px;
  position: relative;
}
.user .left ul li a {
  float: left;
  color: #666;
}
.user .left ul li.active::before {
  content: "";
  width: 2px;
  height: 20px;
  overflow: hidden;
  background: #b4a078;
  position: absolute;
  top: 5px;
  left: 0;
}
.user .left ul li.active a {
  color: #b4a078;
}
.user .right {
  float: right;
  width: 982px;
}
</style>